module.exports = __webpack_public_path__ + "static/fonts/63aa9f40-04be-453a-a672-aa8f9919115d.75f4b90.woff";